import { useState } from 'react';
import { useIntl } from 'umi';
import { notification } from 'tea-component';
import { deleteComparingGamesPlus } from '../services';
import type { ICommonActionRes } from '@/pages/intelligence/types/common';
import type { IPCConsoleGame } from '@/pages/intelligence/types/pcConsoleCompare';

export default function useDeleteGames(option: {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  games: IPCConsoleGame[];
  deleteComparingGames?: (ids: string[]) => Promise<ICommonActionRes>;
}) {
  const { setIsLoading, games, deleteComparingGames: deleteComparingGamesOutter } = option || {};

  const { formatMessage } = useIntl();

  const deleteComparingGames =
    typeof deleteComparingGamesOutter === 'function'
      ? deleteComparingGamesOutter
      : deleteComparingGamesPlus;

  const [visible, setVisible] = useState(false);

  const handleDelete = async (game: IPCConsoleGame): Promise<ICommonActionRes> => {
    const deleteGamesIds = game?.gameId ? [game?.gameId] : [];
    setIsLoading?.(true);
    const deleteRes = await deleteComparingGames(deleteGamesIds);
    setIsLoading?.(false);
    return deleteRes;
  };

  const handleClearAllClick = (e: React.SyntheticEvent<HTMLSpanElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    setVisible(true);
  };

  const handleClearAllConfirm = async (
    e?: React.MouseEvent<Element, MouseEvent>,
  ): Promise<ICommonActionRes> => {
    e?.stopPropagation();
    e?.preventDefault();
    setIsLoading?.(true);
    setVisible(false);
    const gamesIds = games?.map((game) => game?.gameId) || [];
    const deleteRes = await deleteComparingGames(gamesIds);
    if (deleteRes?.status) {
      notification.success({
        // description: formatMessage({ id: 'dbi_operation_successfully_tips' }),
        description: formatMessage({ id: 'dbi_common_operation_succeed_tips' }),
        duration: 3000,
      });
    } else {
      notification.error({
        // description: formatMessage({ id: 'dbi_operation_failly_tips' }),
        description: formatMessage({ id: 'dbi_common_operation_failed_tips' }),
        duration: 3000,
      });
    }
    setIsLoading?.(false);
    return deleteRes;
  };

  const handleClearAllCancel = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    setVisible(false);
  };

  const handleClearAllClose = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    setVisible(false);
  };

  return {
    visible,
    onDelete: handleDelete,
    onClearAllClick: handleClearAllClick,
    onClearAllConfirm: handleClearAllConfirm,
    onClearAllCancel: handleClearAllCancel,
    onClearAllClose: handleClearAllClose,
  };
}
